import { SET_CATALOG_STYLE } from '../actionsTypes';
import { GRID_STYLE } from '../../constants';
import { setSession, getSession } from '../../utilites';

const CATALOG_STYLE_STATE = 'CATALOG_STYLE_STATE';

const initialState = getSession(CATALOG_STYLE_STATE) || {
  style: GRID_STYLE,
};

const catalogStyleReducer = (state = initialState, action) => {
  const newState = (action.type === SET_CATALOG_STYLE)
    ? { ...state, style: action.payload } : state;
  setSession(CATALOG_STYLE_STATE, newState);
  return newState;
};

export default catalogStyleReducer;
